import type { DispatchPreview } from '../dispatch.api';
import { isTopUpStatus } from '../policies/top-up-status.policy';
import { DispatchTopUp } from './DispatchTopUp';
import { TripCashPanel } from './TripCashPanel';

interface DispatchCashTabProps {
  preview: DispatchPreview;
  canTopUp: boolean;
  canViewCash: boolean;
  canRecordCash: boolean;
  onChanged: () => void;
}

/** The money on a trip that has gone: add cash for the driver, and what was given against what was spent. */
export function DispatchCashTab({ preview, canTopUp, canViewCash, canRecordCash, onChanged }: DispatchCashTabProps) {
  const driver = preview.crew.driver;
  const canGiveTopUp = canTopUp && driver !== null && isTopUpStatus(preview.trip.status);
  return (
    <>
      {canGiveTopUp && <DispatchTopUp tripId={preview.trip.id} driverName={driver.label} onGiven={onChanged} />}
      {canViewCash && <TripCashPanel tripId={preview.trip.id} tripNumber={preview.trip.number} canRecord={canRecordCash} />}
    </>
  );
}
